import WhitepapersShow from './WhitepapersShow'

export default WhitepapersShow
